/**
 * Endkundenrechner API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum Familienstand {

    Ledig = 'Ledig',

    Verheiratet = 'Verheiratet',

    Geschieden = 'Geschieden',

    Verwitwet = 'Verwitwet',

    GetrenntLebend = 'GetrenntLebend',

    EheaehnlichEGemeinschaft = 'Eheaehnlich_eGemeinschaft',

    EingetrageneLebenspartnerschaft = 'Eingetragene_Lebenspartnerschaft',

    Sonstiges = 'Sonstiges'
}

